module.exports = __webpack_public_path__ + "static/media/Checked.794efc84.png";